var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreentick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.0007 5.33333C25.014 5.33333 19.334 11.0133 19.334 18C19.334 24.8533 24.694 30.4 31.6807 30.64C31.894 30.6133 32.1073 30.6133 32.2673 30.64C32.3207 30.64 32.3473 30.64 32.4006 30.64C32.4273 30.64 32.4273 30.64 32.454 30.64C39.2806 30.4 44.6406 24.8533 44.6673 18C44.6673 11.0133 38.9873 5.33333 32.0007 5.33333Z",
    fill: "#78C257"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5485 37.76C38.1085 32.8 25.9752 32.8 18.4818 37.76C15.0952 40 13.2285 43.0667 13.2285 46.3467C13.2285 49.6267 15.0952 52.6667 18.4552 54.9067C22.1885 57.4133 27.0952 58.6667 32.0018 58.6667C36.9085 58.6667 41.8152 57.4133 45.5485 54.9067C48.9085 52.64 50.7752 49.6 50.7752 46.2933C50.7485 43.04 48.9085 39.9733 45.5485 37.76ZM38.2152 44.16L31.4952 50.88C31.1752 51.2 30.7485 51.36 30.3218 51.36C29.8952 51.36 29.4685 51.1733 29.1485 50.88L25.7885 47.52C25.1485 46.88 25.1485 45.8133 25.7885 45.1733C26.4285 44.5333 27.4952 44.5333 28.1352 45.1733L30.3218 47.36L35.8685 41.8133C36.5085 41.1733 37.5752 41.1733 38.2152 41.8133C38.8818 42.4533 38.8818 43.52 38.2152 44.16Z",
    fill: "#78C257"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreentick);
export default __webpack_public_path__ + "static/media/greentick.b34f02e7ff125e64806ac9942e257e4f.svg";
export { ForwardRef as ReactComponent };